// ARTICLES
export const FETCH_ARTICLE_OG_ERROR = 'FETCH_ARTICLE_OG_ERROR';
export const FETCH_ARTICLE_OG_SUCCESS = 'FETCH_ARTICLE_OG_SUCCESS';
export const REQUEST_ARTICLE_OG = 'REQUEST_ARTICLE_OG';

// ACTIONS
export const FETCH_ACTIONS_ERROR = 'FETCH_ACTIONS_ERROR';
export const FETCH_ACTIONS_SUCCESS = 'FETCH_ACTIONS_SUCCESS';
export const REQUEST_ACTIONS = 'REQUEST_ACTIONS';

// TRUMPISMS
export const FETCH_TRUMPISMS_ERROR = 'FETCH_TRUMPISMS_ERROR';
export const FETCH_TRUMPISMS_SUCCESS = 'FETCH_TRUMPISMS_SUCCESS';
export const GET_TRUMPISM_ERROR = 'GET_TRUMPISM_ERROR';
export const GET_TRUMPISM_SUCCESS = 'GET_TRUMPISM_SUCCESS';
export const REQUEST_FETCH_TRUMPISMS = 'REQUEST_FETCH_TRUMPISMS';
export const REQUEST_GET_TRUMPISM = 'REQUEST_GET_TRUMPISM';



// WEBPACK FOOTER //
// ./src/actions/types.js